import React from "react";
import { MistyLogo } from "./ImageSlot";
import { ChevronDown } from "lucide-react";

export const Hero = () => {
  const heroBg =
    "https://static.prod-images.emergentagent.com/jobs/75583e4e-b777-4bba-a58d-da083d51985e/images/15b72b597fe8a7246b19ecc2a03a8380ffe0ecc607cab6bdf21b1dec64bfca23.png";

  const scrollToProducts = () => {
    const el = document.querySelector("#products");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[calc(100vh-72px)] flex flex-col items-center justify-center overflow-hidden text-center px-6"
      data-testid="hero-section"
    >
      {/* Background layer */}
      <div
        className="absolute inset-0 z-0 opacity-25 mix-blend-screen bg-cover bg-center"
        style={{ backgroundImage: `url(${heroBg})` }}
      />

      {/* Animated smoke layers — rising from the bottom */}
      <div className="smoke-stage z-0" aria-hidden="true">
        <div className="smoke-glow" />
        <div className="smoke-layer smoke-layer-1" />
        <div className="smoke-layer smoke-layer-2" />
      </div>

      <div className="absolute inset-0 z-0 bg-[radial-gradient(circle_at_50%_50%,rgba(74,144,217,0.12),transparent_70%)]" />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-transparent via-transparent to-misty-base" />

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center gap-8 animate-fade-up">
        <p
          className="text-misty-steel text-[10px] sm:text-xs tracking-[0.5em] uppercase font-sans"
          data-testid="hero-eyebrow"
        >
          Premium Vape Distribution — South Africa
        </p>
        <MistyLogo size="xl" testId="hero-logo" />
        <div className="w-16 h-px bg-misty-steel/60" />
        <p
          className="text-misty-muted text-base sm:text-lg lg:text-xl max-w-2xl leading-relaxed font-sans"
          data-testid="hero-tagline"
        >
          Bringing the world's finest vaping devices to distributors, retailers
          and consumers in South Africa.
        </p>
        <button
          onClick={scrollToProducts}
          className="mt-4 bg-misty-steel hover:bg-misty-steelHi text-misty-base px-10 py-4 font-sans font-semibold tracking-[0.15em] uppercase text-xs transition-colors group"
          data-testid="hero-cta-button"
        >
          Explore Products
          <span className="inline-block ml-2 transition-transform group-hover:translate-x-1">
            →
          </span>
        </button>
      </div>

      {/* Scroll indicator — hidden on shorter viewports so it doesn't overlap the CTA */}
      <div
        className="hidden lg:flex absolute bottom-4 left-1/2 -translate-x-1/2 z-10 flex-col items-center gap-1 pointer-events-none"
        data-testid="scroll-indicator"
      >
        <span className="text-misty-dim text-[9px] tracking-[0.4em] uppercase">
          Scroll
        </span>
        <div className="w-px h-8 bg-gradient-to-b from-misty-steel/60 to-transparent relative overflow-hidden">
          <div className="absolute top-0 left-0 w-px h-3 bg-misty-steel animate-scroll-hint" />
        </div>
        <ChevronDown size={12} className="text-misty-steel/60" />
      </div>
    </section>
  );
};
